import React from 'react';
import { Text, Box } from '@cad-arc';
import { EsriMapTooltip } from '../hooks/use-esri-map-markers';

export const EsriMapViewTooltip: React.FC<EsriMapTooltip> = ({ label, posX, posY }) => {
    return (
        <Box
            className=""
            zIndex="var(--arc-zIndices-tooltip)"
            p="1"
            border="sm"
            borderColor="border.default"
            bg="surface.canvas"
            position="absolute"
            top={`${posY}px`}
            left={`${posX}px`}
            boxShadow="shadows.lg">
            <Text variant="bodyMd" color="primary">{label}</Text>
        </Box>
    );
};
